const _upper = (text) => {
    if (!text || typeof text !== 'string') return ''

    return text.toUpperCase()
}

export default (items) => {
    const vItems = Array.isArray(items) ? items : []

    const statistics = {}
    const _addItem = (type, size) => {
        const {total, sizes} = Object.assign({total: 0, sizes: {}}, statistics[type])
        const vTotal = total > 0 ? parseInt(total, 10) : 0

        const vSizes = Object.assign({}, sizes)
        const totalBySize = vSizes[size] || 0
        const vTotalBySize = totalBySize > 0 ? parseInt(totalBySize, 10) : 0
        const increasedTotalBySize = vTotalBySize + 1

        const increasedSizes = Object.assign({}, vSizes, {
            [size]: increasedTotalBySize
        })
        const increasedTotal = vTotal + 1

        statistics[type] = {
            total: increasedTotal,
            sizes: increasedSizes,
        }
    }

    vItems.forEach(item => {
        const {product} = item
        if (!product || typeof product !== 'object') return false

        const {type, size} = product

        const TYPE = _upper(type)
        const SIZE = _upper(size)

        return _addItem(TYPE, SIZE)
    })

    const arr = []
    for (let productType in statistics) {
        const {total, sizes} = statistics[productType]

        const arrSizes = []
        for (let sizeKey in sizes) {
            const totalBySize = parseInt(sizes[sizeKey] || 0, 10)

            arrSizes.push({
                size: sizeKey,
                total: totalBySize
            })
        }

        arr.push({
            type: productType,
            total,
            sizes: arrSizes
        })
    }

    return arr
}

